/**
 * Sections 11-14: Property Valuation - Comparables 1-4
 * Reusable component for all four comparable sections
 */

import { useCallback } from 'preact/hooks';
import { useForm } from '@ox/visits-ui/context/FormContext';
import { Input, Textarea } from '@ox/visits-ui/components/shared/FormComponents';

interface ComparableProps {
  compNumber: 1 | 2 | 3 | 4;
}

export function Section11Comparable({ compNumber }: ComparableProps) {
  const { formData, updateField } = useForm();

  const addressField = `comp_${compNumber}_address`;
  const mlsIdField = `comp_${compNumber}_mls_id`;
  const conditionField = `comp_${compNumber}_condition`;

  const handleAddressChange = useCallback(
    (value: string) => updateField(addressField, value),
    [updateField, addressField],
  );

  const handleMlsIdChange = useCallback(
    (value: string) => updateField(mlsIdField, value),
    [updateField, mlsIdField],
  );

  const handleConditionChange = useCallback(
    (value: string) => updateField(conditionField, value),
    [updateField, conditionField],
  );

  return (
    <div className="form-section">
      <h2>Property Valuation: Comparable {compNumber}</h2>

      <Input
        label={`Comparable ${compNumber}: Address`}
        name={addressField}
        value={formData[addressField] || ''}
        onChange={handleAddressChange}
        placeholder="Full address"
        required
      />

      <Input
        label={`Comparable ${compNumber}: MLS ID`}
        name={mlsIdField}
        value={formData[mlsIdField] || ''}
        onChange={handleMlsIdChange}
        placeholder="MLS listing ID"
        required
      />

      <Textarea
        label={`Comparable ${compNumber}: Overall Condition`}
        name={conditionField}
        value={formData[conditionField] || ''}
        onChange={handleConditionChange}
        placeholder='Example: "Home has more updated flooring and kitchen finishes compared to subject property. Original tile flooring throughout. Lot size is also significantly larger."'
        rows={5}
        hintMessage="This should be at least 2-3 sentences, covering where the differences are noted."
        required
      />
    </div>
  );
}
